import { z } from 'zod';
import { ROLES } from '../estados';
import { esPermiso, type Permiso } from '../permisos';
import { passwordNueva } from './auth';
import { centavosPositivos, uuid } from './comunes';

const permiso = z.string().refine(esPermiso, 'Permiso desconocido') as unknown as z.ZodType<Permiso>;

export const nombreUsuario = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9._-]{3,40}$/, 'Usa de 3 a 40 letras, números, punto, guion o guion bajo');

export const crearUsuarioSchema = z.object({
  nombre: z.string().trim().min(2).max(120),
  usuario: nombreUsuario,
  password: passwordNueva,
  rol: z.enum(ROLES),
  email: z.string().trim().email().max(200).optional(),
  telefono: z.string().trim().max(30).optional(),
  sueldoSemanal: centavosPositivos.nullable().optional(),
  sucursalIds: z.array(uuid).min(1).optional(),
});
export type CrearUsuarioInput = z.infer<typeof crearUsuarioSchema>;

export const actualizarUsuarioSchema = crearUsuarioSchema.omit({ password: true, usuario: true }).partial();
export type ActualizarUsuarioInput = z.infer<typeof actualizarUsuarioSchema>;

export const permisosUsuarioSchema = z.object({
  extras: z.array(permiso).max(100),
  revocados: z.array(permiso).max(100),
});
export type PermisosUsuarioInput = z.infer<typeof permisosUsuarioSchema>;

export const activoSchema = z.object({ activo: z.boolean() });
export const restablecerPasswordSchema = z.object({ password: passwordNueva });

export interface UsuarioVista {
  id: string;
  nombre: string;
  usuario: string;
  email: string | null;
  telefono: string | null;
  rol: (typeof ROLES)[number];
  activo: boolean;
  permisosExtra: Permiso[];
  permisosRevocados: Permiso[];
  sueldoSemanal: number | null;
  sucursalIds: string[];
  registradoPor: { id: string; nombre: string } | null;
  createdAt: string;
}
